module.exports = __webpack_public_path__ + "static/media/toolbar-zoom-in.04432cf2.svg";